export default __webpack_public_path__ + "static/media/frame.30d5cd3a.svg";